<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil</v-icon>
        <v-toolbar-title v-if="del">Reject Request - enter password</v-toolbar-title>
        <v-toolbar-title v-else>Approve Request - enter password</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card-title>Enter password:</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="mainForm.password"
              :label="labels.password"
              :error-messages="errors.collect('mainForm.password')"
              data-vv-name="mainForm.password"
              :data-vv-as="mainForm.password"
              v-validate="'required'"
              :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPwd ? 'text' : 'password'"
              @click:append="showPwd = !showPwd"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn color="error" dark class=" mr-2"  @click.native="doCancel()">Cancel</v-btn>
              <v-btn color="primary" :loading="loading"  @click.native="doCapturePwd()">OK</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { labels } from '@/const/common'
export default {
  props: {
    clmNo: {
      required: true
    },
    clmStat: {
    },
    screen: {
      required: true
    },
    del: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      mainForm: {
        password: null,
        clmNo: null,
        clmStat: null,
        del: null
      },
      labels: {
        password: labels.Password
      },
      showPwd: false,
      loading: false
    }
  },
  computed: {
    menu() {
      return this.$store.state.user.notification.menu
    }
  },
  methods: {
    async doCapturePwd() {
      let apiUrl
      if (this.screen === true) {
        apiUrl = this.$store.state.commons.menu.captureAuthNotifRes
      } else if (this.screen === false) {
        apiUrl = this.$store.state.commons.menu.captureAuthNotifPayt
      } else {
        apiUrl = this.$store.state.commons.menu.captureAuthNotifStatus
      }
      if (apiUrl) {
        this.loading = true
        this.mainForm.clmNo = this.clmNo
        this.mainForm.clmStat = this.clmStat
        this.mainForm.del = this.del
        this.$http.get(expandURI(apiUrl, this.mainForm)).then(result => {
          const data = result.data
          if (data) {
            if (data.messages[0].type === 'SUCCESS') {
              this.loading = false
              this.$toast.success(data.messages[0].message)
              this.$emit('captureAuth')
              this.doCloseAndInit()
            } else {
              this.$toast.error(data.messages[0].message)
            }
          }
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.loading = false
            this.$toast.error(data.messages[0].message)
          }
        })
        this.loading = false
      } else {
        this.loading = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.mainForm.password = null
      this.$emit('close')
    },
    async doCloseAndInit() {
      this.mainForm.password = null
      if (this.screen === null) {
        this.$emit('returnClmManagement')
      }
      await this.$emit('updateRecord')
      this.$emit('init')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>
